import React, {Component} from 'react';

import {Alert, Card, CardBody, CardTitle,} from 'reactstrap';
import usersValidator from '../../helpers/usersValidator';
import {connect} from 'react-redux';
import {push} from 'connected-react-router';
import {
	deleteUser,
	fetchUsers,
	saveNewUser,
	updateSingleUser,
	uploadOperatorUserFile,
	uploadUserFile
} from '../../actions/usersActions';
import {fetchRoles} from '../../actions/rolesActions';
import {closeAlert} from '../../actions/commonsActions';
import {updateUserAttributes} from '../../actions/attributesActions';
import {fetchCompanies} from "../../actions/companyActions";
import {ACTIVE, SUPER_ADMIN, USER, USER_ROLES} from '../../helpers/constants';
import {I18n} from '../../I18n/components/users';
import DeleteUserModal from "./DeleteUserModal";
import UploadUserModal from "./UploadUserModal";
import UserModal from "./UserModal";
import UsersControls from "./UsersControls";

import 'react-table/react-table.css';
import './users.css';
import UsersList from "./UsersList";
import {fetchTinyStoresWithOperator} from "../../actions/storesActions";

class Users extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currentPage: 0,
			paginatedList: [],
			prev_filters: [],
			active_filters:[],
			modal: false,
			newUser: {
				id: null,
				login: '',
				name: '',
				email: '',
				phoneNumber: null,
				role: '',
				status:'',
				password: '',
				repeatPassword: '',
				companyId: '',
				defaultPassword: true,
                visibleSalesPointIds: [],
			},
			isOkModal: false,
			activeUserId: null,
			editMode: false,
			isAddUserOpen: false,

			filters: [],
			filter: '',
			status: '',
			role: '',
			companyId: '',
			//order: 'DESC',
			sortState: {
				id: 'name',
				desc: true
			},
			sorting: false,

			uploadModal: false,
			uploadFileName: "Выбор файла",
			uploadFile: null,
			isFileUpload: false,
			isSaveDisable: false,
			defaultPasswordChecked: false
		};
		this.validators = usersValidator;
	}

	componentDidMount() {
		(async () => {
			await this.props.fetchUsers({
				page: 0
			});
			await this.getAdditionalUserData()
		})();
	}

	updateUserAttributesList = async attributes => {
		if (!attributes) {
            this.handleSubmit()
		} else {
            await this.props.updateUserAttributes(attributes);
            await this.fetchPaginatedData(this.state.currentPage);
            setTimeout(() => {
                this.props.closeAlert();
            }, 3000);
		}
	};

	fetchPaginatedData = async currentPage => {
		await this.props.fetchUsers({
			filters: this.state.filters.length ? this.state.filters : false,
			sorting: this.state.sorting ? this.state.sorting : false,
			page: currentPage
		});
		await this.setState({
			currentPage,
			sortState: this.state.sorting ? this.state.sorting : {
				id: 'name',
				desc: true
			}
		});
	};

	setCurrentPage = async currentPage => {
		this.setState({
			currentPage
		}, () => {
			this.fetchPaginatedData(currentPage)
		});
	};

	toggle = async () => {
		// console.log('toggle', this.state.modal)
		// if (this.state.modal) {
		// 	this.clearNewUserState();
		// 	console.log('close', this.state)
		// }
		this.setState({
			modal: !this.state.modal,
			defaultPasswordChecked: false
		});
	};

	isOkModalToggle = id => {
		this.setState({
			isOkModal: !this.state.isOkModal,
			activeUserId: id
		});
	};

    getAdditionalUserData = () => {
        const {authority, company} = this.props;
        const companyId = authority !== SUPER_ADMIN ? company.id : null;
        return Promise.all([
            this.props.fetchCompanies(),
            this.props.fetchRoles(),
            this.props.fetchTinyStoresWithOperator(companyId)]);
    };

	setDefaultFormData = () => {
		Object.keys(this.validators).forEach(elem => {
			this.validators[elem].errors = [];
			this.validators[elem].state = '';
			this.validators[elem].valid = true;
		});
		this.clearNewUserState();
	};

	addUserClick = async () => {
		this.setDefaultFormData();
		if (!this.props.companies.length && !this.props.roles.length) {
			await this.getAdditionalUserData();
		}
		this.toggle();
	};

	deleteUser = async() => {
		console.log('delete user');
		await this.props.deleteUser(this.state.activeUserId);
		await this.fetchPaginatedData(0);
		this.setState({
			activeUserId: null
		}, this.isOkModalToggle(null))
	};

	handleSubmit = async (event) => {
		if (event) {
			event.preventDefault();
        }
        if (this.state.newUser.defaultPassword) {
            ['password', 'repeatPassword', 'isPasswordEqual', 'phoneNumber'].forEach(elem => {
                this.validators[elem].errors = [];
                this.validators[elem].state = '';
                this.validators[elem].valid = true;
            });
        }
		let users = this.props.users || [];
		if (this.isFormValid()) {
			await this.setState({
				isSaveDisable: true
			});
			try {
				if (users.filter(user => user.id === this.state.newUser.id).length === 0) {
					this.props.saveNewUser(this.state.newUser)
						.then(async newUser => {
							await this.setState({
								isSaveDisable: false,
								currentPage: 0
							});
							this.fetchPaginatedData(0);
							this.clearNewUserState();
							this.toggle();
						}, error => {
							throw new Error(error.statusText)
						})
				} else {
					this.props.updateSingleUser(this.state.newUser)
						.then(async user => {
							await this.setState({
								isSaveDisable: false,
								currentPage: 0
							});
							this.fetchPaginatedData(0);
							this.clearNewUserState();
							this.toggle();
						}, error => {
							throw new Error(error.statusText)
						})
				}
			} catch(error) {
				console.log(error);
				await this.setState({
					isSaveDisable: false
				})
			}
		}
	};

	clearNewUserState = async () => {
		const {authority, company} = this.props;
		await this.setState({
			newUser: {
				id: null,
				login: '',
				name: '',
				email: '',
				phoneNumber: null,
				password: '',
				repeatPassword: '',
                companyId: authority === SUPER_ADMIN ? null : company.id,
				role: USER,
				status: ACTIVE,
				defaultPassword: true,
				defaultPasswordChecked: false,
                visibleSalesPointIds: [],
			},
			activeUserId: null,
			editMode: false
		});
	};

	onChangePasswd = event => {
		//const value = event.target.checked;
		const value = !this.state.defaultPasswordChecked;
		const user = {...this.state.newUser};
		user.defaultPassword = value;
		if (value) {
            if (this.props.companies.length === 1 &&
            	this.props.companies[0].newUserDefaultPassword) {
                user.password =  this.props.companies[0].newUserDefaultPassword;
                user.repeatPassword = this.props.companies[0].newUserDefaultPassword;
            } else {
                user.password =  '';
                user.repeatPassword = '';
			}
			this.validators['password'].errors = [];
			this.validators['password'].state = '';
			this.validators['password'].valid = true;
			this.validators['repeatPassword'].errors = [];
			this.validators['repeatPassword'].state = '';
			this.validators['repeatPassword'].valid = true;
			this.validators['isPasswordEqual'].errors = [];
			this.validators['isPasswordEqual'].state = '';
			this.validators['isPasswordEqual'].valid = true;
		}
		this.setState({
			newUser: user,
			defaultPasswordChecked: value
		}, () => {
			console.log(this.state)
		});
	};

    onChangeVisibleSalesPoints = visibleSalePoints => {
        const allOptions = visibleSalePoints.find(option => Array.isArray(option.value));
        const visibleSalesPointIds = allOptions
            ? allOptions.value
            : visibleSalePoints.map(sp => sp.value);
        this.setState({
            newUser: {
                ...this.state.newUser,
                visibleSalesPointIds
            },
        });
    }

	onInputChange = event => {
		const name = event.target.name;
		const value = event.target.value;
		if ( name === 'password' || name === 'repeatPassword') {
			this.formValidators(name, value);
			this.formValidators('isPasswordEqual',
				{
					prev: this.state.newUser.password,
					next: name === 'repeatPassword' ?
						value : this.state.repeatPassword
				});
		} else {
			this.formValidators(name, value);
		}
		this.setState(state => ({
			newUser: Object.keys(state.newUser).reduce((res, key) => {
				if (key === name) {
					let tempValue = [];
					if (Array.isArray(state.newUser[key])) {
						tempValue = value.split(',');
						tempValue = tempValue.length === 1 && tempValue[0] === '' ? [] : tempValue;
					} else {
						tempValue = value;
					}
					res[key] = tempValue; //(Array.isArray(state.newAttribute[key])) ? value.split(',') : value;
				} else {
					res[key] = state.newUser[key];
				}
				return res
			},{})
		}), () => {

		});
	};

	onFilterClick = name => {
		return event => {
			const value  = event.target.value;
			this.setState(state => {
				const filteredElemIndex = state.filters.findIndex(item => item.name === name);
				let filters = [...state.filters];
				if (filteredElemIndex !== -1) {
					if (value && value !== '') {
						filters[filteredElemIndex].name = name;
						filters[filteredElemIndex].value = value;
					} else {
						filters = filters.filter(elem => elem.name !== name);
					}
				} else {
					filters = [...state.filters, {name : name, value: value}]
				}
				return {
					[`${name}`]: value,
					filters: filters
				}
			}, () => {
				this.fetchPaginatedData(0);
			})
		}
	};

	clearFilters = () => {
		this.setState({
			filters: [],
			status: '',
			role: '',
			filter: '',
			companyId: '',
			//order: 'ASC',
		}, () => {
			this.fetchPaginatedData(0);
		})
	};

	formValidators = (fieldName, value) => {
		this.validators[fieldName].errors = [];
		this.validators[fieldName].state = value;
		this.validators[fieldName].valid = true;
		this.validators[fieldName].rules.forEach(rule => {
			if (this.state.editMode && fieldName === 'password' || this.state.editMode && fieldName === 'repeatPassword') {
				return;
			}
			if (this.state.newUser.defaultPassword && fieldName === 'password' ||
				this.state.newUser.defaultPassword && fieldName === 'repeatPassword' ||
				this.state.newUser.defaultPassword && fieldName === 'isPasswordEqual') {
				this.validators[fieldName].errors = [];
				this.validators[fieldName].state = '';
				this.validators[fieldName].valid = true;
				return;
			}
			if (rule.test instanceof RegExp) {
				if (!rule.test.test(value)) {
					this.validators[fieldName].errors.push(rule.message);
					this.validators[fieldName].valid = false;
				}
			} else if (typeof rule.test === 'function') {
				if (!rule.test(value)) {
					this.validators[fieldName].errors.push(rule.message);
					this.validators[fieldName].valid = false;
				}
			}

		});
		console.log(this.validators);
	};

	isFormValid = () => {
		let status = true;
		Object.keys(this.validators).forEach(field => {
			if (!this.validators[field].valid) {
				status = false;
			}
		});
		return status;
	};

	showErrors = fieldName => {
		const validator = this.validators[fieldName];
		const result = '';
		if (validator && !validator.valid) {
			const errors = validator.errors.map((info, index) => {
				return (
					<span className="error" key={index}>
           			 	* {info}
						<br/>
          			</span>
				);
			});

			return <div className="error mb-2">{errors}</div>;
		}
		return result;
	};

	toggleUploadModal = () => {
		this.setState({
			uploadModal: !this.state.uploadModal,
			uploadFileName: null,
			uploadFile: null,
		});
	};

	sendFile = event => {
		event.preventDefault();
		this.setState({
			isFileUpload: true
		});
		const request = this.props.company.types.includes('OPERATOR')
			? this.props.uploadOperatorUserFile(this.state.uploadFile)
			: this.props.uploadUserFile(this.state.uploadFile)
		request.then( res => {
				console.log('FINAL--', res);
				this.toggleUploadModal();
				this.setState({
					uploadFile: null,
					uploadFileName: null,
					isFileUpload: false
				});
				this.fetchPaginatedData(0)
			})
	};

	onFileSelect = event => {
		if (event.target.files[0]) {
			const name = event.target.files[0].name;
			const file = event.target.files[0];
			const data = new FormData();
			const companyId = this.props.companies.length === 1 ?  this.props.companies[0].id : null;
			data.append('file', file);
            data.append('companyId', companyId);
			this.setState({
				uploadFileName: name,
				uploadFile: data,
			})
		}
	};

	onEditUser = async (id) => {
		if (!this.props.companies.length && !this.props.roles.length) {
			await this.getAdditionalUserData()
		}
		let selectedUser = this.props.users.find(item => item.id === id);
		Object.keys(this.validators).forEach(elem => {
			this.validators[elem].errors = [];
			this.validators[elem].state = '';
			this.validators[elem].valid = true;
		});
		this.setState({
			modal: !this.state.modal,
			newUser: selectedUser,
			editMode: true,
		});
	};

	sortBy = async sortState => {
		const sorting = {...sortState[0]};
		await this.setState({
			sorting: sorting
		});
		await this.fetchPaginatedData(0);
	};

	render() {
		const {lang, loading, companies, tinyStoresWithOperator} = this.props;
		const userList = loading ? <div className="loading">Loading...</div> : <UsersList
			lang={this.props.lang}
			users={this.props.users}
			currentPage={this.state.currentPage}
			companies={companies}
			roles={this.props.roles}
			onEditUser={this.onEditUser}
			isOkModalToggle={this.isOkModalToggle}
			setCurrentPage={this.setCurrentPage}
			totalPages={this.props.pagination.totalPages}
			sortBy={this.sortBy}
			sortState={this.state.sortState}
		/>

		return (
			<div className='users '>
				{/*----------------------- alerts -----------------------------------*/}
				<Alert
					color={`${this.props.alert.alert.status}`}
					isOpen={this.props.alert.isOpen || false}
				>
					{this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed": ''}
				</Alert>
				<UploadUserModal
					lang={this.props.lang}
                	uploadModal={this.state.uploadModal}
					toggle={this.toggleUploadModal}
                    sendFile={this.sendFile}
                    onFileSelect={this.onFileSelect}
                    uploadFileName={this.state.uploadFileName}
                    uploadFile={this.state.uploadFile}
                    isFileUpload={this.state.isFileUpload}
				/>
				<DeleteUserModal
					lang={this.props.lang}
					isOkModal={this.state.isOkModal}
					toggle={this.isOkModalToggle}
					deleteUser={this.deleteUser}
				/>
				<UserModal
					lang={this.props.lang}
					isModal={this.state.modal}
					toggle={this.toggle}
					newUser={this.state.newUser}
                    handleSubmit={this.handleSubmit}
                    onInputChange={this.onInputChange}
                    editMode={this.state.editMode}
                    showErrors={this.showErrors}
                    companies={companies}
                    roles={this.props.roles}
                    onChangePasswd={this.onChangePasswd}
                    isSaveDisable={this.state.isSaveDisable}
                    updateUserAttributesList={this.updateUserAttributesList}
                    authority={this.props.authority}
					defaultPasswordChecked={this.state.defaultPasswordChecked}
                    tinyStoresWithOperator={tinyStoresWithOperator}
                    onChangeVisibleSalesPoints={this.onChangeVisibleSalesPoints}
				/>
				<Card>
					<CardTitle className="mb-0 p-3 border-bottom bg-light">
						<div>
							<i className="mdi mdi-border-right mr-2"></i>{I18n[lang].userList_title}
						</div>
						{/*<Button color="primary" type="button" onClick={this.addAttributeClick}>Добавить атрибут</Button>*/}
					</CardTitle>

					<CardBody>
						<div>
							<UsersControls
								lang={this.props.lang}
								status={this.state.status}
								onFilterClick={this.onFilterClick}
								authority={this.props.authority}
								companies={this.props.companies}
								companyId={this.state.companyId}
								//order={this.state.order}
								role={this.state.role}
								filter={this.state.filter}
								clearFilters={this.clearFilters}
								addUserClick={this.addUserClick}
								toggleUploadModal={this.toggleUploadModal}
							/>
							{userList}
						</div>
					</CardBody>
				</Card>
			</div>
		)
	}
};

const mapDispatchToProps = dispatch => {
	return {
		fetchUsers: query => dispatch(fetchUsers(query)),
		closeAlert: () => dispatch(closeAlert()),
		changeLocation: url => dispatch(push(url)),
		fetchCompanies: query => dispatch(fetchCompanies(query)),
        fetchTinyStoresWithOperator: (operatorCompanyId) => dispatch(fetchTinyStoresWithOperator(operatorCompanyId)),
		fetchRoles: query => dispatch(fetchRoles(query)),
		updateSingleUser: user => dispatch(updateSingleUser(user)),
		saveNewUser: user => dispatch(saveNewUser(user)),
		deleteUser: userId => dispatch(deleteUser(userId)),
		updateUserAttributes: attributes => dispatch(updateUserAttributes(attributes)),
		uploadUserFile: file => dispatch(uploadUserFile(file)),
		uploadOperatorUserFile: file => dispatch(uploadOperatorUserFile(file)),
	};
};

const mapStateToProps = state => ({
	alert: state.alert,
	users: state.users.users,
	pagination: state.users.pagination,
	loading: state.users.loading,
    company: state.companiesReducer.companies.length > 1 ? {id: 1} : state.companiesReducer.companies[0],
    companies: state.companiesReducer.companies,
    tinyStoresWithOperator: state.tinyStoresWithOperatorReducer.tinyStoresWithOperator,
	roles: state.rolesReducer.roles,
	authority:  state.currentUser.roles[0].authority || USER_ROLES.GUEST,
	lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(Users)



// WEBPACK FOOTER //
// ./src/components/Users/Users.js